import StatusLine from "./StatusLine.jsx";

// Step three. eBay Plus returns are collected rather than posted, so that
// channel gets a different set of instructions.
export default function ThankYouPage({ data }) {
  const { labels, carrier, ebayPlus, backPath, steps } = data;

  return (
    <div className="customers">
      <div className="gr-12">
        <div className="top-buffer-s">
          <StatusLine steps={steps} active={3} />
        </div>
      </div>

      <div className="gr-12 bottom-buffer-m">
        <div className="section-headline" />

        {ebayPlus ? (
          <>
            <p
              style={{ color: "red" }}
              dangerouslySetInnerHTML={{ __html: labels.ebay.continue }}
            />
            <ul className="list">
              {labels.ebay.steps.map((step, i) => (
                <li key={i}>
                  <p dangerouslySetInnerHTML={{ __html: step }} />
                </li>
              ))}
            </ul>
            <p dangerouslySetInnerHTML={{ __html: labels.ebay.information }} />
            <p dangerouslySetInnerHTML={{ __html: labels.ebay.refund }} />
          </>
        ) : (
          <>
            <h2>{labels.thankYou}</h2>
            <p>{labels.howToContinue}</p>
            <ul className="list">
              {labels.steps.map((step, i) => (
                <li key={i}>
                  <p>{step}</p>
                </li>
              ))}
            </ul>
            <div id="service" className="bottom-buffer-s">
              <p>{labels.noDocuments}</p>
              <p>
                {labels.viaMail}{" "}
                <a href={backPath} target="_self">
                  {labels.again}
                </a>{" "}
                {labels.popUp}
              </p>
            </div>
          </>
        )}

        {carrier && (
          <>
            <br />
            <div className="row">
              <div className="gr-12 text_center">
                <div className="section-headline">
                  <h2>{carrier.heading}</h2>
                </div>
                {carrier.iframe ? (
                  <div className="section-frame">
                    <iframe
                      className={`shop_frame ${carrier.name}`}
                      src={carrier.stationSearch}
                      scrolling="no"
                      title={carrier.heading}
                    />
                  </div>
                ) : (
                  <a
                    href={carrier.stationSearch}
                    className="button-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {carrier.linkText}
                  </a>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
